import React, { useEffect, useMemo, useState } from 'react';
import { IndicacionInput } from '../StepProgramaAE/IndicacionInput';
import toast from 'react-hot-toast';

export const StepProgramaAO = ({
    setDataSubmissionCallback,
    pantallas,
    idDatosGeneralesRI,
    edit
}) => {
    const [childrenAction, setChildrenAction] = useState(null);
    const [tieneIndicaciones, setTieneIndicaciones] = useState(false);

    const idPantallaRI = useMemo(() => {
        return pantallas.find(p => p.displayName.includes('AO'))?.id
    }, [pantallas]);

    useEffect(() => {
        if (!tieneIndicaciones) {
            setDataSubmissionCallback(() => {
                toast.error('Agregar al menos una indicación');
            })
        } else {
            setDataSubmissionCallback(null);
        }
    }, [setDataSubmissionCallback, tieneIndicaciones]);

    return (
        <div>
            <div className='step-form-section-container'>
                <label className={`step-form-section-title ${childrenAction ? 'with-children-action' : ''}`}>
                    Indicaciones
                    {Boolean(childrenAction) && childrenAction}
                </label>
                <IndicacionInput
                    idDatosGeneralesRI={idDatosGeneralesRI}
                    setTieneIndicaciones={setTieneIndicaciones}
                    idPantallaRI={idPantallaRI}
                    setChildrenAction={setChildrenAction}
                    edit={edit}
                />
            </div>
        </div>
    )
}